export const regions = [
  {
    name: 'Africa',
    countries: [
      { name: 'Egypt', lang: 'English', locale: 'en', flag: 'eg' },
      { name: 'Ghana', lang: 'English', locale: 'en', flag: 'gh' },
      { name: 'Guinea-Bissau', lang: 'Portuguese', locale: 'pt', flag: 'gw' },
      { name: 'Madagascar', lang: 'French', locale: 'fr', flag: 'mg' },
      { name: 'Morocco', lang: 'English', locale: 'en', flag: 'ma' },
      { name: 'Nigeria', lang: 'English', locale: 'en', flag: 'ng' },
      { name: 'South Africa', lang: 'English', locale: 'en', flag: 'za' },
    ],
  },
  {
    name: 'Asia',
    countries: [
      { name: 'China', lang: 'English', locale: 'en', flag: 'cn' },
      { name: 'India', lang: 'English', locale: 'en', flag: 'in' },
      { name: 'Indonesia', lang: 'English', locale: 'en', flag: 'id' },
      { name: 'Japan', lang: 'English', locale: 'en', flag: 'jp' },
      { name: 'Singapore', lang: 'English', locale: 'en', flag: 'sg' },
      { name: 'South Korea', lang: 'English', locale: 'en', flag: 'kr' },
      { name: 'Turkey', lang: 'English', locale: 'en', flag: 'tr' },
      { name: 'United Arab Emirates', lang: 'English', locale: 'en', flag: 'ae' },
    ],
  },
  {
    name: 'Australia',
    countries: [
      { name: 'Australia', lang: 'English', locale: 'en', flag: 'au' },
      { name: 'New Zealand', lang: 'English', locale: 'en', flag: 'nz' },
    ],
  },
  {
    name: 'Europe',
    countries: [
      { name: 'France', lang: 'French', locale: 'fr', flag: 'fr' },
      { name: 'Germany', lang: 'German', locale: 'de', flag: 'de' },
      { name: 'Italy', lang: 'Italian', locale: 'it', flag: 'it' },
      { name: 'Portugal', lang: 'Portuguese', locale: 'pt', flag: 'pt' },
      { name: 'Spain', lang: 'Spanish', locale: 'es', flag: 'es' },
      { name: 'Ukraine', lang: 'Ukrainian', locale: 'uk', flag: 'ua' },
      { name: 'United Kingdom', lang: 'English', locale: 'en', flag: 'gb' },
    ],
  },
  {
    name: 'North America',
    countries: [
      { name: 'Canada', lang: 'English', locale: 'en', flag: 'ca' },
      { name: 'Mexico', lang: 'Spanish', locale: 'es', flag: 'mx' },
      { name: 'United States', lang: 'English', locale: 'en', flag: 'us' },
    ],
  },
  {
    name: 'South America',
    countries: [
      { name: 'Argentina', lang: 'Spanish', locale: 'es', flag: 'ar' },
      { name: 'Bolivia', lang: 'Spanish', locale: 'es', flag: 'bo' },
      { name: 'Brazil', lang: 'Portuguese', locale: 'pt', flag: 'br' },
      { name: 'Chile', lang: 'Spanish', locale: 'es', flag: 'cl' },
      { name: 'Colombia', lang: 'Spanish', locale: 'es', flag: 'co' },
      { name: 'Ecuador', lang: 'Spanish', locale: 'es', flag: 'ec' },
      { name: 'Guyana', lang: 'English', locale: 'en', flag: 'gy' },
      { name: 'Paraguay', lang: 'Spanish', locale: 'es', flag: 'py' },
      { name: 'Peru', lang: 'Spanish', locale: 'es', flag: 'pe' },
      { name: 'Suriname', lang: 'English', locale: 'en', flag: 'sr' },
      { name: 'Uruguay', lang: 'Spanish', locale: 'es', flag: 'uy' },
      { name: 'Venezuela', lang: 'Spanish', locale: 'es', flag: 've' },
    ],
  },
]
